export enum OnboardingStep {
    PickLocation = "pick-location",
    PushPermission = "push-permission",
    // Final confirmation screen, not counted as a step in the progress bar
    Done = "done",
}

export const ONBOARDING_STEP_COUNT = 2

export type PushPermissionResult = Readonly<{
    // undefined: the user skipped the step (or permission could not be requested)
    granted: boolean | undefined
    forTx: boolean
    forNews: boolean
}>
